module.exports = __webpack_public_path__ + "src/assets/img/logo-pril.c7623935.svg";